import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/base/SEOSchema';
import { comics, features, testimonials, faqs, categories } from '@/mocks/comics';

export default function Home() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  const homepageSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '动漫之家',
      url: 'http://hgok7.com/',
      description: '动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新。',
      sameAs: ['http://hgok7.com/'],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '动漫之家',
      url: 'http://hgok7.com/',
      description: '动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://hgok7.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '动漫之家 - 韩漫在线免费阅读',
      description: '动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。',
      url: 'http://hgok7.com/',
    },
  ];

  return (
    <>
      <SEOSchema
        schemas={homepageSchemas}
        canonicalUrl="http://hgok7.com/"
        pageTitle="韩国漫画-无删减漫画下拉式-韩漫在线免费阅读-动漫之家"
        pageDescription="动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。"
        pageKeywords="韩国漫画,无删减漫画,下拉式漫画,韩漫在线免费阅读,动漫之家,优质阅读平台"
        ogTitle="韩国漫画-无删减漫画下拉式-韩漫在线免费阅读-动漫之家"
        ogDescription="动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。"
      />

      <Navbar />

      {/* Hero Section */}
      <header className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20cinematic%20scene%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20city%20nightscape%20with%20neon%20accents%2C%20emotional%20atmosphere%2C%20couple%20silhouette%20against%20golden%20sunset%2C%20webtoon%20aesthetic%2C%20rich%20color%20gradient%2C%20high%20contrast%20moody%20style&width=1920&height=1080&seq=hero-bg-home-001&orientation=landscape"
            alt="动漫之家 - 韩国漫画在线免费阅读平台"
            title="韩国漫画,下拉式漫画,韩漫在线免费阅读"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>

        <div className="relative z-10 h-full flex flex-col justify-end pb-24 px-6 md:px-14 lg:px-20">
          <div className="w-full max-w-4xl">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white text-xs font-label font-medium tracking-wider mb-6">
              无删减 · 下拉式 · 免费阅读
            </span>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-light text-white leading-tight tracking-tight text-balance">
              韩国漫画
              <br />
              在线免费阅读
            </h1>
            <p className="mt-6 text-base md:text-lg text-white/80 font-body leading-relaxed max-w-xl">
              收录5000+部无删减韩国漫画，下拉式流畅阅读体验。
              <br />
              热门新作实时更新，画质高清，为你打造优质阅读平台。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link
                to="/category/romance"
                className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-label font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer inline-flex items-center justify-center gap-2"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-8 py-3.5 rounded-full border border-white/40 text-white text-sm font-label font-medium hover:bg-white/10 transition-all duration-200 cursor-pointer inline-flex items-center justify-center"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main>
        {/* Feature Grid */}
        <section className="bg-background-100 py-20 md:py-28 px-6 md:px-14 lg:px-20">
          <div className="max-w-7xl mx-auto">
            <div className="mb-16">
              <span className="text-xs font-label font-medium text-foreground-400 uppercase tracking-widest">
                为什么选择我们
              </span>
              <h2 className="mt-3 text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
                专注韩漫，
                <br />
                只为更好阅读
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {features.map((feature, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-2xl p-8 md:p-10 hover:bg-background-50/80 transition-colors duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center mb-6">
                    <i className={`${feature.icon} text-3xl text-foreground-950`}></i>
                  </div>
                  <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Comics Grid */}
        <section className="bg-background-100 py-20 md:py-28 px-6 md:px-14 lg:px-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14 gap-4">
              <div>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
                  热门
                  <br />
                  推荐
                </h2>
              </div>
              <p className="text-sm text-foreground-500 font-body max-w-md leading-relaxed">
                精选最受欢迎的韩国漫画，每日更新，让你不错过任何一部精彩作品。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {hotComics.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 韩国漫画,无删减韩漫`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3 flex gap-2">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-label font-semibold ${
                        comic.status === '连载中'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-accent-500 text-background-50'
                      }`}>
                        {comic.status}
                      </span>
                      {comic.isNew && (
                        <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label font-semibold">
                          NEW
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-lg font-heading font-bold text-foreground-950 mb-1.5">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-3">{comic.author} · {comic.categoryName}</p>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-primary-500 w-3 h-3 flex items-center justify-center"></i>
                        {comic.rating}
                      </span>
                      <span>{comic.views.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            <div className="mt-12 text-center">
              <Link
                to="/category/romance"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-label font-semibold hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                浏览全部漫画
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Categories Quick Nav */}
        <section className="bg-background-50 py-20 md:py-28 px-6 md:px-14 lg:px-20">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-14">
              分类浏览
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer group"
                >
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-50 group-hover:bg-primary-500/10 transition-colors">
                    <i className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-primary-500 transition-colors`}></i>
                  </div>
                  <span className="text-sm font-label font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</span>
                  <span className="text-xs text-foreground-400">{cat.count.toLocaleString()} 部</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-background-50 py-20 md:py-28 px-6 md:px-14 lg:px-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-0" style={{ width: '100%' }}>
              <div className="lg:w-[6fr] pr-0 lg:pr-16">
                <div className="flex items-center gap-2 mb-8">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                  <span className="text-xs font-label font-semibold text-foreground-500 tracking-widest uppercase">
                    用户好评
                  </span>
                </div>

                <div className="relative">
                  {testimonials.map((t, idx) => (
                    <blockquote
                      key={t.id}
                      className={`${idx > 0 ? 'mt-12 pt-12 border-t border-background-200' : ''}`}
                    >
                      <p className="text-xl md:text-2xl font-heading font-medium text-foreground-900 leading-relaxed italic">
                        {t.content}
                      </p>
                      <footer className="mt-5 flex items-center gap-3">
                        <span className="text-sm font-label font-bold text-foreground-950">
                          {t.name}
                        </span>
                        <span className="text-xs text-foreground-400">{t.role}</span>
                        <span className="flex items-center gap-0.5 ml-2">
                          {[...Array(t.rating)].map((_, i) => (
                            <i key={i} className="ri-star-fill text-accent-500 text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
                          ))}
                        </span>
                      </footer>
                    </blockquote>
                  ))}
                </div>
              </div>

              <div className="lg:w-[4fr] flex items-center justify-center">
                <div className="w-full h-[400px] rounded-3xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20young%20reader%20enjoying%20webtoon%20on%20smartphone%20in%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20soft%20natural%20window%20light%2C%20relaxed%20and%20immersed%20expression%2C%20lifestyle%20photography%2C%20minimal%20composition%2C%20clean%20aesthetic%2C%20warm%20cream%20and%20brown%20tones&width=600&height=800&seq=testimonial-side-001&orientation=portrait"
                    alt="读者沉浸在韩漫阅读中"
                    title="韩漫在线免费阅读体验"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-background-100 py-20 md:py-28 px-6 md:px-14 lg:px-20">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 text-center mb-14">
              常见问题
            </h2>

            <div className="space-y-4">
              {faqs.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-2xl overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-base font-label font-semibold text-foreground-900 pr-6">
                      {faq.question}
                    </h3>
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-500 group-open:text-background-50 transition-all duration-200 flex-shrink-0">
                      <i className="ri-add-line group-open:ri-subtract-line text-sm"></i>
                    </span>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Schema JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />

        {/* CTA Section */}
        <section
          className="relative h-screen w-full overflow-hidden"
          aria-label="开始阅读行动号召"
        >
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20soft%20evening%20light%2C%20tablet%20displaying%20colorful%20comic%20art%2C%20hot%20drink%20on%20wooden%20table%2C%20ambient%20warm%20lighting%20from%20lamp%2C%20comfortable%20atmosphere%2C%20relaxing%20home%20interior%2C%20golden%20hour%20tones%2C%20cozy%20and%20inviting%20mood&width=1920&height=1080&seq=cta-bg-home-001&orientation=landscape"
              alt="开始阅读韩国漫画"
              title="韩漫在线免费阅读"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          </div>

          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-semibold text-white tracking-wide mb-6">
              立即开始阅读
            </h2>
            <p className="text-base md:text-lg text-white/80 font-body max-w-lg leading-relaxed mb-10">
              加入数百万韩漫爱好者，畅享无删减
              <br />
              下拉式漫画阅读体验
            </p>
            <Link
              to="/category/romance"
              className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-label font-semibold hover:bg-foreground-800 transition-all duration-200 cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-play-fill text-background-50 text-xs"></i>
              </span>
              开始阅读
              <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}